/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommissionRecommendCodeVo
 */
export interface CommissionRecommendCodeVo {
    /**
     * 推荐码id
     * @type {number}
     * @memberof CommissionRecommendCodeVo
     */
    id?: number;
    /**
     * 推荐码
     * @type {string}
     * @memberof CommissionRecommendCodeVo
     */
    code?: string;
}

/**
 * Check if a given object implements the CommissionRecommendCodeVo interface.
 */
export function instanceOfCommissionRecommendCodeVo(value: object): value is CommissionRecommendCodeVo {
    return true;
}

export function CommissionRecommendCodeVoFromJSON(json: any): CommissionRecommendCodeVo {
    return CommissionRecommendCodeVoFromJSONTyped(json, false);
}

export function CommissionRecommendCodeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionRecommendCodeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
    };
}

export function CommissionRecommendCodeVoToJSON(json: any): CommissionRecommendCodeVo {
    return CommissionRecommendCodeVoToJSONTyped(json, false);
}

export function CommissionRecommendCodeVoToJSONTyped(value?: CommissionRecommendCodeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
    };
}

